import { attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  name: attr('string'),
  earnings: attr('number'),
  projectCount: attr('number'),
  slug: attr('string'),
  startDate: attr('date'),
  endDate: attr('date')
});
